module.exports = __webpack_public_path__ + "static/media/new-collapsed-brand-logo.2906194a.svg";